import React from 'react';

import { cssMap, cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { useChild } from '../../hooks/useChildren.tsx';
import type { A2UIComponentDefinition } from '../../types/A2UIComponents.types.tsx';
import type { A2UICardProps } from '../../types/A2UIComponents.types.tsx';

const styles = cssMap({
	card: {
		paddingTop: token('space.200'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.200'),
		borderRadius: token('radius.large'),
		backgroundColor: token('elevation.surface'),
		boxShadow: token('elevation.shadow.raised'),
	},
});

type Props = {
	definition: A2UIComponentDefinition;
	visited?: Set<string>;
};

export const A2UICard = ({ definition, visited }: Props): React.JSX.Element => {
	const def = definition as A2UICardProps;
	const child = useChild(def.child, visited);

	return <Box xcss={cx(styles.card)}>{child}</Box>;
};
